import { css } from "@emotion/react";
import { kitText } from "../../styles";

export const styles = {
  input: css`
    color: var(--color-primary);
    font-size: var(--font-size-body);
    font-family: var(--font-family-body);
    padding-left: var(--spacing-24) !important;
    color: var(--color-primary) !important;
    --indicator-border-color: var(--color-border-primary);
    --indicator-bg-color: var(--color-background-secondary);
    .bp4-control-indicator {
      width: var(--spacing-16);
      height: var(--spacing-16);
      background: var(--indicator-bg-color);
      outline: none !important;
      &::before {
        background-color: var(--indicator-bg-color) !important;
        border-radius: 50% !important;
        opacity: 1 !important;
        box-shadow: inset 0 0 0 1px var(--indicator-border-color);
      }
    }
    &:not(.bp4-align-right) .bp4-control-indicator {
      margin-left: calc(var(--spacing-24) * -1) !important;
    }
    input:focus ~ .bp4-control-indicator {
      --indicator-border-color: var(--color-border-primary);
      --indicator-bg-color: var(--color-background-secondary);
    }
    input:checked ~ .bp4-control-indicator {
      --indicator-bg-color: var(--color-splash-primary);
      --indicator-border-color: var(--color-splash-primary);
    }
    input:checked:focus ~ .bp4-control-indicator {
      --indicator-bg-color: var(--color-splash-tertiary);
      --indicator-border-color: var(--color-splash-tertiary);
    }
    input:checked:hover ~ .bp4-control-indicator {
      --indicator-bg-color: var(--color-splash-secondary);
      --indicator-border-color: var(--color-splash-secondary);
    }
    input:disabled ~ .bp4-control-indicator {
      --indicator-bg-color: var(--color-background-tertiary);
      --indicator-border-color: var(--color-border-secondary);
    }
    input:disabled:checked ~ .bp4-control-indicator {
      background: transparent !important;
      --indicator-bg-color: var(--color-border-primary);
      --indicator-border-color: var(--color-border-primary);
    }
  `,
  error: css`
    .bp4-control-indicator {
      --indicator-border-color: var(--color-danger) !important;
    }
  `,
  chipInput: css`
    all: unset;
  `,
  chipError: css`
    border-color: var(--color-danger);

    &:focus-within,
    &:hover {
      border-color: var(--color-danger);
    }
  `,
  chipVariant: css`
    ${kitText.variant.body}
    display: flex;
    align-items: center;
    width: fit-content;
    max-height: var(--spacing-24);
    padding: var(--spacing-4) var(--spacing-8);
    border: 1px solid var(--color-border-secondary);
    border-radius: var(--border-radii-base);
    background-color: var(--color-background-primary);
    cursor: pointer;
    user-select: none;

    &:focus-within,
    &:hover {
      border-color: var(--color-border-primary);
    }
  `,
  chipSelected: css`
    border-color: var(--color-primary);

    &:focus-within,
    &:hover {
      border-color: var(--color-primary);
    }
  `,
  // chipDisabled uses hardcoded #e7e9ef instead of var(--color-background-selected) because that variable has an incorrect value in the default theme
  chipDisabled: css`
    background-color: #e7e9ef;
    color: var(--color-secondary);
    cursor: not-allowed;

    &:focus-within,
    &:hover {
      border-color: transparent;
    }
  `
};
